import React from 'react'

import UserChangelogSingle from '@/components/users/screens/UserChangelogSingle'
import { withSessionInServer } from '@/lib/helpers/nextHelpers'
import type { IChangelogWithFaqs } from '@/types/changelog'

interface IPropTypes {
  changelog?: IChangelogWithFaqs
}

export default function ChangelogSinglePage({ changelog }: IPropTypes) {
  return <UserChangelogSingle changelog={changelog} />
}

export const getServerSideProps = withSessionInServer(async (ctx: any) => {
  try {
    const isDataReq = ctx.req?.url?.startsWith('/_next/data')
    if (isDataReq) return { props: {} }

    // const { params } = ctx
    // const changelog = await getSSRChangelogSingle(
    //   params.changelogSlug,
    //   headers
    // )

    return {
      props: {
        changelog: null,
      },
    }
  } catch {
    return {
      props: {
        changelog: null,
      },
    }
  }
})
